// extracted by mini-css-extract-plugin
export default {"rootLayout":"RootLayout_rootLayout__-o+GM","rootLayoutContent":"RootLayout_rootLayoutContent__+t3Bi"};